export default "__VITE_ASSET__BcquN920__"